/* eslint-disable @typescript-eslint/camelcase */

import React from "react";
import {
    ProductHeaderSerializer,
    ProductDescriptionSerializer,
    ProductMoreDescriptionsSerializer,
    BuyBuyBuyAreaSerializer,
} from "web/types/serializers";
import PriceRange from "web/react/components/buybuybuy-area/price-range/price-range";
import SizeGuide from "web/react/components/buybuybuy-area/size-guide/size-guide";
import BuyOptions from "web/react/components/buybuybuy-area/buy-options/buy-options";
import ProductHeader from "web/react/components/buybuybuy-area/product-header/product-header";
import ProductDescription from "web/react/components/buybuybuy-area/product-description/product-description";

interface BuyAreaProps {
    csrfToken: string;
    header?: ProductHeaderSerializer | null;
    buyAreaOptions?: BuyBuyBuyAreaSerializer | null;
    productDescription?: ProductDescriptionSerializer | null;
    productMoreDescriptions?: ProductMoreDescriptionsSerializer | null;
    isOverlay?: boolean;
}

function BuyArea({
    header,
    csrfToken,
    buyAreaOptions,
    productDescription,
    productMoreDescriptions,
    isOverlay,
}: BuyAreaProps): React.ReactElement | null {
    if (!buyAreaOptions) {
        return null;
    }

    const {
        min_and_max_price_are_the_same,
        has_regular_price,
        multiple_stores,
        regular_price_with_currency_symbol,
        minimum_price_with_currency_symbol,
        maximum_price_with_currency_symbol,
        size_guide_link,
        form_action,
        return_url,
        available_sizes,
        sizes,
        stores_tip,
        country,
        buybuybuy_options: {
            with_search,
            icon_options,
            affiliate_options,
            product_id,
            is_saved_for_later,
        },
    } = buyAreaOptions;

    return (
        <div className="buybuybuy-area">
            {header && <ProductHeader {...header} />}
            <PriceRange
                minMaxSame={min_and_max_price_are_the_same}
                hasRegularPrice={has_regular_price}
                multipleStores={multiple_stores}
                regularPriceWithCurrencySymbol={regular_price_with_currency_symbol as string}
                minimumPriceWithCurrencySymbol={minimum_price_with_currency_symbol}
                maximumPriceWithCurrencySymbol={maximum_price_with_currency_symbol}
            />
            <SizeGuide sizeGuideLink={size_guide_link} />
            <BuyOptions
                withSearch={with_search}
                isOverlay={isOverlay}
                iconOptions={icon_options}
                affiliateOptions={affiliate_options}
                productId={product_id}
                isSavedForLater={is_saved_for_later}
                sizeOptionsForm={{
                    csrfToken: csrfToken,
                    action: form_action,
                    country: country,
                    returnUrl: return_url,
                    availableSizes: available_sizes,
                    sizes: sizes,
                    storesTip: stores_tip,
                }}
            />
            {productDescription && (
                <ProductDescription
                    {...productDescription}
                    more_descriptions={productMoreDescriptions}
                />
            )}
        </div>
    );
}

export default BuyArea;
